import {Injectable} from '@angular/core';
import {POObjectEffects} from '@store/effects/POObject.effect';
import {POOperatorGroup} from '@obj-models/POOperatorGroup';

@Injectable()
export class POOperatorGroupEffects extends POObjectEffects<POOperatorGroup> {
  constructor() {
    super(POOperatorGroup.type);
  }
}
